import React from "react";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { AlertTriangle } from "lucide-react";

const DeceasedConfirmationView = ({
  userData,
  isAdminMode,
  onReturnToAdmin,
  onExit,
}) => {
  return (
    <div className="min-h-screen p-4 bg-gradient-to-br from-slate-50 via-amber-50 to-slate-100 w-full flex items-center justify-center">
      <div className="max-w-3xl w-full">
        <Card className="p-5 sm:p-7 md:p-10 shadow-2xl border-0 bg-white/95 backdrop-blur-sm text-center">
          <div className="mx-auto w-10 h-10 sm:w-14 sm:h-14 md:w-16 md:h-16 rounded-full bg-statusWarningBg flex items-center justify-center mb-4 sm:mb-6">
            <AlertTriangle className="w-5 h-5 sm:w-7 sm:h-7 md:w-8 md:h-8 text-amber-600" />
          </div>
          <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-foreground mb-3 sm:mb-4">
            Atenção: Substituído Falecido
          </h2>
          <p className="text-foreground mb-8">
            O cadastro foi salvo, mas como o substituído é falecido, é necessário que os herdeiros entrem em contato diretamente com o departamento jurídico do sindicato para dar continuidade ao processo.
          </p>
          {!isAdminMode && (
            <p className="text-foreground mb-8">
              Para mais informações, entre em contato com: (11) 93333-3012
            </p>
          )}
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {isAdminMode ? (
              <Button onClick={onReturnToAdmin} className="w-full sm:w-auto h-11 px-6">
                Voltar ao Painel de Admin
              </Button>
            ) : (
              <Button onClick={onExit} className="w-full sm:w-auto h-11 px-6">
                Sair do Sistema
              </Button>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default DeceasedConfirmationView;
